export const githubUrl =
  'https://api.github.com/repos/sierrawang/the-code-life/contents/assignments';

export const githubUrlPublic =
  'https://github.com/sierrawang/the-code-life/tree/main/assignments';
